import * as React from 'react';
import { useState } from 'react';
import { Link} from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import vindrApi from "../utils/vindrapi";
import {formatDate} from "../utils/functions";
import Pagination			from "../components/Pagination";

import DataTable, { createTheme } from 'react-data-table-component';


createTheme(
	'vlist',
	{
		background: {
			default: 'transparent',
		},
		headRow: {

		}
	},
	'light',
);

		
class DialogVersions extends React.Component {
	
	state = {
		data: [],
		pending: true
	};	
	
	constructor(props) {
		super(props);
	}


	handleClose(data){
		this.props.onClose(data);
		this.setState({ data: [], pending:true });
	};
	handleOnShow(e){
		
		this.scenarioid = this.props.setup.scenario.scenario_id ?? this.props.setup.scenario.scenarioid;
		this.projectid = this.props.setup.scenario.projectid;
		
		vindrApi.getScenarioVersions(this.projectid, this.scenarioid).then((data)=>{

			this.setState({ data: data, pending:false });

			this.forceUpdate();
		}).catch((e)=>{
			
		});
		
		
	};

	handleRowsPerPageChange = (rows)=>{
		//saveRows(rows);
	}
	

	render() {
		
	
		
		return (
			<Modal className="list-versions" show={!!this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Scenario Versions</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				<DataTable
					data={this.state.data}
					columns={[
						{
							name:'Date',
							selector: row => row.timestamp,
							format: (row) =>  (formatDate(row.timestamp))
						},
						{
							name:'Message',
							selector: row => row.log,
							omit: this.props.scenario ? this.props.scenario.scenario_id : false,
							wrap:true,
							grow:1
						},
						{
							name: 'User',
							selector: row => row.username,
							center:'true',
						},
						{
							name:'',
							selector: row => row.id,
							format: (row, idx) =>  {return (
								this.state.data[0].id == row.id ? (<Button variant="outline-success" disabled><i className="ri-check-line text-success"></i> Current</Button>) 
								:
								(<a target="_blank" href={'/pages/project/'+this.props.setup.scenario.projectid+'?scenarioid='+this.props.setup.scenario.scenario_id+'&versionid='+row.id} className="btn btn-primary">Preview</a>)
							)},
							right:'true',
						}

					]}
					theme="vlist"
					customStyles={{
						headCells:{
							style: {
								fontWeight:'bold'
							}
						},
					}}

					progressPending={this.state.pending}
					progressComponent={(<Spinner animation="border" variant="success" />)}

					pagination
					onChangeRowsPerPage={this.handleRowsPerPageChange}
					paginationComponent = {Pagination}
					paginationComponentOptions = {{
						rowsPerPageText: 'Show',
						type: 'versions',
						rangeSeparatorText: 'of',
						selectAllRowsItemText: 'All',
					}}
					
				/>
				</Modal.Body>
				<Modal.Footer>
					<Button className="me-auto" variant="secondary" onClick={(e)=>this.handleClose()}>Close</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default DialogVersions;